import { render, staticRenderFns } from "./CreateSendCloudParcel.vue?vue&type=template&id=584c4e78&scoped=true"
import script from "./CreateSendCloudParcel.vue?vue&type=script&lang=ts"
export * from "./CreateSendCloudParcel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c4e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584c4e78')) {
      api.createRecord('584c4e78', component.options)
    } else {
      api.reload('584c4e78', component.options)
    }
    module.hot.accept("./CreateSendCloudParcel.vue?vue&type=template&id=584c4e78&scoped=true", function () {
      api.rerender('584c4e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sendcloud/CreateSendCloudParcel.vue"
export default component.exports